import React from "react";
import { useState } from "react";

import Container from "react-bootstrap/Container";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

import Navbar from "react-bootstrap/Navbar";

import navIcon1 from "../../assets/images/nav-icon1.svg";
import gitIcon from "../../assets/images/gitLinkVector.svg";


import "./NavBar.scss";

const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  // const [theme, setTheme] = useState("dark");

  // const handleThemeChange = () => {
  //   theme === "dark" ? setTheme("light") : setTheme("dark");
  // }

  
  return (
    <Navbar expand="lg" bg="dark" className={""} >
      <Container>
      <Navbar.Brand as={Link} to="/">Dorota Bialy</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link
              as={Link} to="/"
              className={activeLink === "home" ? "active navbar-link" : "navbar-link"}
              onClick={() => setActiveLink("home")}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={Link} to="/skills"
              className={activeLink === "skills" ? "active navbar-link" : "navbar-link"}
              onClick={() => setActiveLink("skills")}
            >
              Skills
            </Nav.Link>
            <Nav.Link
              as={Link} to="/projects"
              className={activeLink === "projects" ? "active navbar-link" : "navbar-link"}
              onClick={() => setActiveLink("projects")}
            >
              Projects
            </Nav.Link>
          </Nav>
          {/* <Nav>
            <div>
              <img src={navIcon1} onClick={handleThemeChange}/>
            </div>
          </Nav> */}
          <Nav className="navbar-text">
            <div className="social-icon">
              <Nav.Link className="nav__link" href="https://www.linkedin.com/in/dorota-b-304064229/" target="_blank" rel="noreferrer">
                <img src={navIcon1} alt="Linked In" />
              </Nav.Link>
              <Nav.Link className="nav__link"  href="https://github.com/DorBia" target="_blank" rel="noreferrer">
                <img src={gitIcon} alt="Github" />
              </Nav.Link>
            </div>
            <Nav.Link className="nav__link" as={Link} to="/contact"> <button className="vvd">
              <span>Contact Form</span>
            </button>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
